import { createContent } from '../../map/commonFunctions';
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions';
import { enableMapObject, disableMapObject } from '../../../action/disable-map-obj-state-action'
import { infoWindowOpenAction, infoWindowCloseAction } from '../../../action/infowindow-action';
import { expandRightToolbar } from '../../../action/right-toolbar-state-actions'
import { photoDeleteRequest } from '../../../action/photo-actions';
import { store } from '../../../lib/store';
import { markerDeleteRequest } from '../../../action/marker-actions'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id'

// Create a div in your HTML file with id="custom-alert" to append the alert box dynamically
const alertContainer = document.createElement('div');
alertContainer.id = 'custom-alert';
document.body.appendChild(alertContainer);

//Function to hide the alert box
function hideAlert() {
  const alertBox = document.querySelector('.custom-alert-content');
  if (alertBox) {
    alertBox.remove();
  }
}

async function remove(id, mapObj, type) {
  try {
    if (type == "Photo") {
      let res = await store.dispatch(photoDeleteRequest(id))
      hideAlert()
      setTimeout(() => {
        mapObj.map = null;
      }, 1000)
    } else {
      let res = await store.dispatch(markerDeleteRequest(id));
      hideAlert()
      setTimeout(() => {
        mapObj.map = null;
      }, 1000)
    }
  } catch (error) {
    console.log('Error at deleteFunction', error)
  }
}

const handleParentClick = (e) => {
  // Prevent the click event from reaching the parent
  e.stopPropagation();
}

// Function to show the alert box
function showAlert(message, type, id, mapObj) {
  const alertBox = document.createElement('div');
  alertBox.classList.add('custom-alert-content');
  alertBox.innerHTML = `
      <span class="close-btn" onclick="hideAlert()">&times;</span>
      <div class='confirm-removal-container-two' onClick="hideAlert()">
          <div class='alert-box-container' onclick="handleParentClick()">
              <div class='alert-center'>
                  <p style="font-size: 18px; margin: 20px; font-weight: bold; text-align: center;line-height: 1.5">Delete this
                      ${type == 'Photo' ? 'Photo Marker' : type} from your map and your saved content?</p>
                  <div style="display: flex; justify-content: space-between; margin-top: 10px;">
                      <button id="close-btn" onclick="hideAlert()" style="margin: 0; width: 45%;">CANCEL</button>
                      <button id="yes-remove" onclick="remove(id,mapObj,type)"
                          style="margin: 0; background-color: #ff6800; width: 45%;">YES, DELETE</button>
                  </div>
              </div>
          </div>
      </div>
  `;
  alertContainer.appendChild(alertBox);
  // Add event listener programmatically
  alertBox.querySelector('#close-btn').addEventListener('click', hideAlert);
  alertBox.querySelector('#yes-remove').addEventListener('click', () => remove(id, mapObj, type))
}

export function renderInfoBox(mapReference, mapObj, markerData, infoWindow, openInfoWindowClose, token, type) {
  const reduxState = store.getState();
  if (reduxState.infoWindow && reduxState.infoWindow.infoWindowFunction) {
    reduxState.infoWindow.infoWindowFunction.close()
  }
  store.dispatch(selectedObjectId(markerData.id))

  let storeInfoBox = (value) => {
    if (infoWindow.infoWindowFunction) {
      store.dispatch(infoWindowOpenAction(value))
    }
  }

  const editFunction = (infoWindow) => {
    store.dispatch(collapseLeftToolbar())
    store.dispatch(expandLeftToolbar({ dialog: 'edit', editable: markerData, mapObj: mapObj }));
    // store.dispatch(disableMapObject())
    google.maps.event.removeListener(mapObj);
    google.maps.event.clearListeners(mapObj, 'click');
    openInfoWindowClose = infoWindow;
    openInfoWindowClose.close();
    if (infoWindow.infoWindowFunction) {
      // store.dispatch(infoWindowOpenAction(null))
    }
    mapReference.setCenter({ lat: markerData.latitude, lng: markerData.longitude })
    mapReference.setZoom(17)
    store.dispatch(selectedObjectIdNull())
  }

  const editHuntWind = (infoWindow) => {
    store.dispatch(collapseLeftToolbar())
    marker['huntWind'] = true
    store.dispatch(expandRightToolbar({ dialog: 'huntWind', data: markerData }))
    // store.dispatch(disableMapObject())
    openInfoWindowClose = infoWindow;
    openInfoWindowClose.close();
    // store.dispatch(infoWindowOpenAction(null))
    mapReference.setCenter({ lat: markerData.latitude, lng: markerData.longitude })
    mapReference.setZoom(17)
    store.dispatch(selectedObjectIdNull())
  }

  const deleteFunction = (value) => {
    showAlert("Message", type, value, mapObj);
    openInfoWindowClose.close();
    // store.dispatch(infoWindowOpenAction(null));
  }

  const closeFunction = (infoWindow) => {
    openInfoWindowClose = infoWindow;
    openInfoWindowClose.close();
    // store.dispatch(infoWindowOpenAction(null))
    store.dispatch(selectedObjectIdNull())
  }

  const updateInfoWindow = (value) => {
    openInfoWindowClose = value
  }

  const dispatchFunction = (value) => {
    storeInfoBox(value)
  }

  let photo = type != "Marker" ? markerData : null
  let marker = type == "Marker" ? markerData : null;

  createContent({ mapReference, mapObj, photo, marker, infoWindow, openInfoWindowClose, token }, { deleteFunction, closeFunction, editFunction, updateInfoWindow, editHuntWind }, dispatchFunction)
}









